
/* eslint-disable */
import {
  readonly,
  ref,
  toRefs,
  useSlots,
  watch
} from 'vue'
import InputText from 'primevue/inputtext'

export default {
  components: {
    InputText
  },
  props: ['icon', 'label', 'modelValue', 'type', 'placeholder', 'canClick', 'inputBackground', 'autofocus', 'disabled', 'readonly', 'value'],
  emits: ['update:modelValue', 'actInput'],
  setup(props: any, {
    emit
  }: any) {
    const slot = useSlots()
    const icon = ref(props.icon)
    const label = ref(props.label)
    const {
      modelValue,
      canClick,
      disabled,
      value
    } = toRefs(props)
    const input = ref((modelValue) ? modelValue.value : '')
    const type = ref(props.type)
    const placeholder = ref(props.placeholder)
    const inputBackground = ref(props.inputBackground)
    const autofocus = ref(props.autofocus)

    watch(value, (newValue) => {
      input.value = newValue
    })

    watch(input, (newValue) => {
      emit('update:modelValue', newValue)
    })

    const onClick = () => {
      if (canClick) {
        emit('actInput')
      }
    }
    const reset = () => {
      input.value = ''
    }

    return {
      icon,
      label,
      input,
      type,
      placeholder,
      canClick,
      onClick,
      reset,
      inputBackground,
      autofocus,
      disabled,
      slot
    }
  }
}
